module.exports = __webpack_public_path__ + "static/img/qax.edf8d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qax.png
// module id = vjDv
// module chunks = 0